import { useQuery } from "react-query";
import API from "../../../services/API";
import moment from "moment";
import useCart from "./useCart";

export default function useDpcSessions(){

    const { cart, setCart } = useCart();

    const query = useQuery({

        queryKey: ['apply', 'sessions', cart.product],

        queryFn: async () => {

            if( !cart.product ){
                
                return [];
            } 

            const response = await API.get(`/dpc/products/${cart.product}/sessions`);

            const sessions = response.data
                .filter(s => moment(s.end).valueOf() > moment().valueOf())
                .sort((a,b) => moment(a.start).diff(moment(b.start)));

            if(sessions.length > 0 && !cart.session ) setCart({ session: sessions[0].id });

            return sessions;
        }


    })

    return query.isSuccess ? query.data : []
}